import React, { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useGlobalContext } from "../../component/GlobalContext";

function PaymentSuccess() {
  const navigate = useNavigate();
  const { globalUserVar,isAuthenticated,setIsAuthenticated } = useGlobalContext();
  const logOutHandler = () => {
    // localStorage.clear();
    // setIsAuthenticated(false);
    navigate('/');
    // window.location.reload()
  }
  useEffect(() => {
    Swal.fire({
      title: "Payment has been Cancelled!",
      text: "You have cancelled your payment!",
      icon: "cancel"
    }).then((result) => {
      if (result.isConfirmed) {
        // Perform your action here (e.g., redirect, reload, logout, etc.)
        logOutHandler();
      }
    });
  }, []);
  return (
    <div>Payment Cancelled</div>
  )
}

export default PaymentSuccess